import client from '@lib/http/client'

export const storePricingAgreement = () => client.post('payments/pricing/info')
